import type { Ref } from 'vue';
import type { ContextType, ExtendedPartTagType } from '@/entities/rubrics';
import { getCityUrl } from '@/entities/rubrics';
import { useTourFiltersStore } from '@/entities/filter/store/tour';
import type { CityTag } from '@/shared/api/experience';
import { useTagRedirect } from '@/shared/lib/redirects/useTagRedirect';
import { allValue, DEFAULT_RUBRIC } from '@/widgets/rubricsBlock/tour';

export function useTourCitySelectedTag(
  cityTags: Ref<CityTag[] | undefined>,
  context: Ref<ContextType>,
  citySlug: Ref<string>,
) {
  const filterStore = useTourFiltersStore();

  const selectedTagFromRoute = computed(() => {
    const foundTag = cityTags.value?.find((tag) => tag.slug === filterStore.searchState.tag__slugs) ?? ({} as CityTag);

    return {
      value: foundTag?.slug || '',
      label: foundTag?.name || '',
      id: foundTag?.id || undefined,
      counter:
        foundTag.slug !== allValue
          ? (foundTag?.counters?.tours_count ?? 0)
          : foundTag?.counters?.[`${context.value}_count`] || undefined,
      url: getCityUrl(context.value, citySlug.value, foundTag.slug || 'all'),
      seoUrl: foundTag.urls?.tours || '',
      // TODO: обсудить с бкэм по поводу редиректов с бэка
      // redirect: foundTag?.redirect || undefined,
      is_tours_included: true,
    };
  });

  useTagRedirect(selectedTagFromRoute);

  const selectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });
  const cachedSelectedValue = ref<ExtendedPartTagType>({ ...DEFAULT_RUBRIC });

  watch(
    () => selectedTagFromRoute.value,
    (newSelectedTagFromRoute) => {
      if (newSelectedTagFromRoute.value) {
        selectedValue.value = newSelectedTagFromRoute;
        cachedSelectedValue.value = newSelectedTagFromRoute;
      }
    },
    { immediate: true },
  );

  return { selectedValue, cachedSelectedValue };
}
